import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../layouts/Dashboard'
import { Button, Col, Spinner, Form, Container, Row, Image } from 'react-bootstrap'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import api from '../../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../../utils/errorApi'
import { useNavigate } from 'react-router-dom'
import { useLoading } from '../../../hooks/LoadingContext'
import UserCircle from '../../../assets/UserCircle.svg'

import styles from './styles.module.css'
import { useAuth } from '../../../hooks/AuthContext'
import { Lock } from 'phosphor-react'
import ChangePasswordModal from '../../../components/ChangePasswordModal'

const AdminEditarUsuario: React.FC = () => {
  const [name, setName] = useState<string>('')
  const [sector, setSector] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [showChangePasswordModal, setShowChangePasswordModal] = useState<boolean>(false)

  const [profilePicture, setProfilePicture] = useState<File | null>()
  const [profilePictureUrl, setProfilePictureUrl] = useState<string>('')

  const { authData } = useAuth()

  const { isLoading, setIsLoading } = useLoading()
  const navigate = useNavigate()

  useEffect(() => {
    async function loadAdmin() {
      try {
        const { data } = await api.get(`/admin/admins/${authData.id}`)
        setName(data.name)
        setSector(data.sector)
        setEmail(data.user.email)
        setProfilePictureUrl(data.user.profilePicture?.url)
      } catch (err) {
        console.error(err)
        toast.error('Falha ao buscar os dados! Atualize a página.')
      }
    }
    loadAdmin()
  }, [authData.id])

  const clearFileInput = (e: any) => {
    const filesData = new DataTransfer()
    e.target.files = filesData.files
  }

  const handlePictureChange = (e: any) => {
    if (e.target.files) {
      const file = e.target.files[0]
      const fileType = file.name.split('.')[1].toLowerCase()

      if (!['jpg', 'png', 'gif', 'jpeg'].includes(fileType)) {
        toast.error('A foto deve possuir formato .PNG, .JPG, .JPEG ou .GIF')
        clearFileInput(e)
        setProfilePicture(null)
        setProfilePictureUrl('')
      } else {
        setProfilePictureUrl(URL.createObjectURL(e.target.files[0]))
        setProfilePicture(e.target.files[0])
      }
    }
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)

    if (!name || !email) {
      toast.error('Você precisa preencher todos os campos obrigatórios!')
      setIsLoading(false)
      return
    }

    const data = new FormData()
    const model = {
      name,
      sector,
      email,
    }
    data.append('data', JSON.stringify(model))
    if (profilePicture) data.append('image', profilePicture, profilePicture.name)

    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    try {
      await api.put(`/admin/admins/${authData.id}`, data, config)
      toast.info('Admin editado com sucesso!', {
        autoClose: 3000,
      })
      setIsLoading(false)
      navigate('/admin/inicio')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao editar o administrador! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  const isValidModel = () => {
    return name && sector && email
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Editar administrador">
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Editar administrador</h2>
        <Col style={{ textAlign: 'center' }}>
          <Image
            style={{ height: 150, width: 150, borderRadius: 12 }}
            fluid={true}
            src={profilePictureUrl || UserCircle}
          />
        </Col>
        <Col className={styles.form_container}>
          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nome*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o nome"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Foto de perfil (opcional)
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="file"
                placeholder="Selecione a foto de perfil"
                onChange={(event) => {
                  handlePictureChange(event)
                }}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Setor*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o setor"
                value={sector}
                onChange={(event) => setSector(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                E-mail*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o e-mail"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Col>
          </Row>
          <Row
            style={{
              paddingBottom: 12,
              textAlign: 'left',
            }}
          >
            <Col md={6} style={{ marginTop: 15 }}>
              <Button
                className={styles.change_password_button}
                onClick={() => setShowChangePasswordModal(true)}
              >
                Alterar senha <Lock className={styles.lock_icon} size={16} weight={'bold'} />
              </Button>
            </Col>
          </Row>
          <Col style={{ textAlign: 'right' }}>
            <Button
              className={styles.btn_submit}
              disabled={isLoading || !isValidModel()}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Editar administrador'
              )}
            </Button>
          </Col>
        </Col>
      </Container>
      <ChangePasswordModal
        show={showChangePasswordModal}
        closeModal={() => setShowChangePasswordModal(false)}
        id={authData.id}
      />
    </DashboardLayout>
  )
}

export default AdminEditarUsuario
